<template>
    <div class="address-list">
        <h5 class="list__address mb-5" :title="unitLmsgLocation" :style="{webkitLineClamp: addressLinesCount}" >{{unitLmsgLocation}}</h5>
        <h5 class="icon-text mb-5" v-if="unitLmsgGeo" :title="unitLmsgGeo" >
            <SvgIcon class="icon" name="circle___geozone_circle"/>
            <span class="description">{{unitLmsgGeo}}</span>
        </h5>
        <h5 class="icon-text" v-if="drivers" :title="drivers" >
            <SvgIcon class="icon" name="menu__driver_fill"/>
            <span class="description">{{drivers}}</span>
        </h5>
    </div>
</template>
<script>
    import unitLmsgMixin from "@/mixins/unitLmsgMixin";
    import {mapGetters} from "vuex";

    const TOTAL_ADDRESS_LINES = 3;

    export default {
        name: 'UnitsList_unit_address',
        mixins: [unitLmsgMixin],
        props: {
            unitId: Number,
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                "getAppointmentsByUnitsIds",
                "getDriversByIds",
            ]),
            appointments() {
                let dateNow = (Date.now() / 1000);
                return (this.getAppointmentsByUnitsIds[this.unitId] || [])
                    .filter(a => dateNow > a?.time_appointment && (!a?.time_removed || (a?.time_removed > dateNow)))
            },
            drivers() {
                return this.appointments.map(a => {
                    let driver = this.getDriversByIds[a.driver_id]
                    return driver ? (driver.name || '#'+driver.id) : null
                }).filter(Boolean).join('; ')
            },
            unitLmsgGeo() {
                let geozone = this.unitLmsg?.geozone
                return (Array.isArray(geozone) ? geozone.join('; ') : geozone) || '';
            },
            extraRowsCount() {
                return (this.unitLmsgGeo ? 1 : 0) + (this.drivers ? 1 : 0)
            },
            addressLinesCount() {
                return Math.max(TOTAL_ADDRESS_LINES - this.extraRowsCount, 1)
            },
        },
        updated: function() {
           // console.log(`UnitsList_unit_address ${this.unitLmsgLocation} updated`);
        },
    }
</script>
<style scoped lang="scss">
.address-list {
    .mb-5 {
        margin-bottom: 5px;
    }
    .icon {
        margin-right: 5px;
        flex-shrink: 0;
    }
    .icon-text {
        display: flex;
        align-items: center;
    }
    .description {
        font-size: 11px;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>